export default __webpack_public_path__ + "static/media/Savant's Cowl of the Waning Moon.e74d803c.jpg";